<template>
  <div class="on-clock-page">
    <main class="form-content">
      <div class="form-row">
        <label class="form-label">技师号：</label>
        <div class="field-box readonly-field">{{ form.technicianCode }}</div>
      </div>

      <div class="form-row">
        <label class="form-label">项目名称：</label>
        <button type="button" class="field-box select-field" @click="openProjectPicker">
          <span :class="{ placeholder: !form.projectName }">
            {{ form.projectName || "请选择项目" }}
          </span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>

      <div class="form-row">
        <label class="form-label" for="hand-code">手牌号：</label>
        <input
          id="hand-code"
          v-model.trim="form.handCode"
          class="field-box text-input"
          type="text"
          inputmode="numeric"
          placeholder="请输入手牌号"
        />
      </div>

      <div class="form-row">
        <label class="form-label">房间号：</label>
        <button type="button" class="field-box select-field" @click="openRoomPicker">
          <span :class="{ placeholder: !form.roomName }">
            {{ form.roomName || "请选择房间" }}
          </span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>

      <div class="form-row">
        <label class="form-label" for="clock-count">做钟数量：</label>
        <div class="field-box count-field">
          <button
            type="button"
            class="count-button"
            aria-label="减少做钟数量"
            :disabled="form.clockCount <= minClockCount"
            @click="changeClockCount(-1)"
          >
            −
          </button>
          <input
            id="clock-count"
            v-model.number="form.clockCount"
            type="number"
            inputmode="decimal"
            :min="minClockCount"
            :max="maxClockCount"
            step="1"
            @blur="normalizeClockCount"
          />
          <button
            type="button"
            class="count-button"
            aria-label="增加做钟数量"
            :disabled="form.clockCount >= maxClockCount"
            @click="changeClockCount(1)"
          >
            ＋
          </button>
        </div>
      </div>
    </main>

    <footer class="page-footer">
      <button type="button" class="footer-button cancel-button" @click="handleCancel">
        取消
      </button>
      <button type="button" class="footer-button save-button" @click="handleSave">
        确认上钟
      </button>
    </footer>

    <project-select-popup
      v-model="showProjectPicker"
      :projects="projectOptions"
      :selected-id="form.projectId"
      @confirm="confirmProject"
    />

    <room-select-popup
      v-model="showRoomPicker"
      :rooms="roomOptions"
      :categories="roomCategoryOptions"
      :selected-id="form.roomId"
      @confirm="confirmRoom"
    />
  </div>
</template>

<script>
import ProjectSelectPopup from "@/components/jishi/ProjectSelectPopup";
import RoomSelectPopup from "@/components/jishi/RoomSelectPopup";

export default {
  name: "JiShiOnClock",
  components: {
    ProjectSelectPopup,
    RoomSelectPopup,
  },
  data() {
    return {
      showProjectPicker: false,
      showRoomPicker: false,
      minClockCount: 1,
      maxClockCount: 20,
      form: {
        technicianCode: "007",
        projectId: "6001",
        projectName: "精油按摩",
        handCode: "6002",
        roomId: "00005",
        roomName: "00005",
        clockCount: 1,
      },
      // 项目弹窗的唯一数据源；接口接入后保持 id、name、price、unit 字段即可。
      projectOptions: [
        { id: "6001", name: "精油按摩", price: 299, unit: "成人" },
        { id: "6002", name: "颈肩按摩", price: 398, unit: "1大1小" },
        { id: "6003", name: "足底按摩", price: 668, unit: "成人" },
        { id: "6004", name: "全身推拿", price: 68, unit: "成人" },
        { id: "6005", name: "艾灸养生", price: 368, unit: "成人" },
        { id: "6006", name: "特价按摩", price: 168, unit: "成人" },
      ],
      roomCategoryOptions: ["全部", "双人间三楼", "大床房三楼", "双人棋牌室", "大床房"],
      // 房间是弹窗唯一数据源；接口接入后保持字段结构一致即可继续使用筛选和统计。
      roomOptions: [
        { id: "00001", name: "00001", type: "按摩房", category: "双人间三楼", status: "preClock", detailLines: ["开 6002　按 6003", "02 颈肩按摩　点", "03 颈肩按摩　排"], elapsed: "00:23" },
        { id: "00002", name: "00002", type: "大床房", category: "大床房三楼", status: "occupied", detailLines: ["主 6005　同 6006", "07.02 15:30-07.03 15:30"], elapsed: "02:36" },
        { id: "00003", name: "00003", type: "标准间", category: "双人间三楼", status: "occupied", detailLines: ["主 6005　同 6006", "07.02 15:30-07.03 15:30"], elapsed: "00:12", timeout: true },
        { id: "00004", name: "00004", type: "棋牌室", category: "双人棋牌室", status: "idle", detailLines: [] },
        { id: "00005", name: "00005", type: "棋牌室", category: "双人棋牌室", status: "idle", detailLines: [] },
        { id: "00006", name: "00006", type: "标准间", category: "双人间三楼", status: "occupied", detailLines: ["主 6005　同 6006", "07.02 15:30-07.03 15:30"], elapsed: "02:19" },
        { id: "00007", name: "00007", type: "按摩房", category: "双人间三楼", status: "working", detailLines: ["开 6002　按 6003", "02 颈肩按摩　点　00:23", "03 颈肩按摩　排　00:36"] },
        { id: "00008", name: "00008", type: "套房", category: "大床房", status: "reserved", handCode: "6002", guestName: "安安", reserveTime: "12.26 15:30" },
        { id: "00009", name: "00009", type: "按摩房", category: "双人间三楼", status: "cleaning", detailLines: ["开 6002　按 6003", "脏房：01:30"] },
        { id: "00010", name: "00010", type: "按摩房", category: "双人间三楼", status: "maintenance", detailLines: [] },
        { id: "00011", name: "00011", type: "按摩房", category: "双人间三楼", status: "retained", detailLines: ["6002"] },
        { id: "00012", name: "00012", type: "棋牌室", category: "双人棋牌室", status: "idle", detailLines: [] },
      ],
    };
  },
  created() {
    this.initializeForm();
  },
  methods: {
    /**
     * 使用路由参数初始化上钟表单。
     * 从钟房页进入时可携带 technicianCode、handCode 等字段；没有传值时保留
     * 页面演示数据，避免直接访问路由时出现空白表单。
     */
    initializeForm() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      this.form.technicianCode = query.technicianCode || this.form.technicianCode;
      this.form.handCode = query.handCode || this.form.handCode;
    },
    /**
     * 打开项目选择器。
     * 具体的回显、单选及取消逻辑由 ProjectSelectPopup 内部负责。
     */
    openProjectPicker() {
      this.showProjectPicker = true;
    },
    /**
     * 接收项目组件确认后返回的完整项目对象，并写入当前表单。
     * 子组件只在用户点击确认时触发此方法，取消和关闭不会修改表单。
     *
     * @param {Object} project 已确认的项目，必须包含 id 和 name。
     */
    confirmProject(project) {
      if (!project) {
        return;
      }
      this.form.projectId = project.id;
      this.form.projectName = project.name;
    },
    /**
     * 打开房间选择器。
     * 搜索、分类、房态筛选、单选和回显逻辑全部由 RoomSelectPopup 内部负责。
     */
    openRoomPicker() {
      this.showRoomPicker = true;
    },
    /**
     * 接收房间组件确认后返回的完整房间对象，并写入当前表单。
     * 子组件取消、关闭或只进行临时选择时不会触发此方法。
     *
     * @param {Object} room 已确认的房间，必须包含 id 和 name。
     */
    confirmRoom(room) {
      if (!room) {
        return;
      }
      this.form.roomId = room.id;
      this.form.roomName = room.name;
    },
    /**
     * 按固定步长修改做钟数量。
     * 每次点击增加或减少 1，并通过上下限约束避免产生无效数量。
     *
     * @param {number} direction 传 1 表示增加，传 -1 表示减少。
     */
    changeClockCount(direction) {
      const currentValue = Number(this.form.clockCount) || this.minClockCount;
      const nextValue = currentValue + direction * 1;
      this.form.clockCount = Math.min(
        this.maxClockCount,
        Math.max(this.minClockCount, nextValue)
      );
    },
    /**
     * 修正用户手动输入的做钟数量。
     * 空值或非数字恢复为最小值，超出范围时截取到允许范围，并统一按 1
     * 的步长四舍五入，确保保存的数据符合业务格式。
     */
    normalizeClockCount() {
      const inputValue = Number(this.form.clockCount);
      const safeValue = Number.isFinite(inputValue) ? inputValue : this.minClockCount;
      const limitedValue = Math.min(
        this.maxClockCount,
        Math.max(this.minClockCount, safeValue)
      );
      this.form.clockCount = Math.round(limitedValue * 2) ;
    },
    /**
     * 取消本次上钟编辑。
     * 有可返回页面时回到上一页；直接打开当前路由时则保持当前页面不变。
     */
    handleCancel() {
      if (window.history.length > 1) {
        this.$router.back();
      }
    },
    /**
     * 校验并提交上钟数据。
     * 当前通过 submit 事件输出完整表单，便于父级或后续接口层接收；接入正式
     * 保存接口时可在本方法中调用接口，成功后再返回钟房页面。
     */
    handleSave() {
      this.normalizeClockCount();
      if (!this.form.technicianCode) {
        this.$toast("缺少技师号");
        return;
      }
      if (!this.form.projectId) {
        this.$toast("请选择项目");
        return;
      }
      if (!this.form.handCode) {
        this.$toast("请输入手牌号");
        return;
      }
      if (!this.form.roomId) {
        this.$toast("请选择房间");
        return;
      }

      this.$emit("submit", { ...this.form });
      this.$toast.success("保存成功");
    },
  },
};
</script>

<style scoped lang="scss">
.on-clock-page {
  min-height: 100vh;
  padding-bottom: calc(118px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #292b2e;
  background: #fffdfa;
}

.form-content {
  padding: 34px 34px 0 28px;
}

.form-row {
  display: flex;
  min-height: 60px;
  align-items: center;
  margin-bottom: 24px;
}

.form-label {
  width: 145px;
  flex: 0 0 145px;
  color: #292b2e;
  font-size: 27px;
  font-weight: 500;
  text-align: right;
}

.field-box {
  display: flex;
  height: 60px;
  min-width: 0;
  flex: 1;
  align-items: center;
  margin-left: 20px;
  padding: 0 24px;
  border: 1px solid #ddd8cc;
  border-radius: 14px;
  box-sizing: border-box;
  color: #a4894f;
  background: #fff;
  box-shadow: 0 1px 4px rgba(117, 101, 70, 0.06);
  font-size: 25px;
  text-align: left;
}

.text-input {
  width: 0;
  outline: none;

  &::placeholder {
    color: #bcb5a8;
  }
}

.readonly-field {
  user-select: none;
}

.select-field {
  justify-content: space-between;

  .placeholder {
    color: #bcb5a8;
  }
}

.arrow-icon {
  width: 10px;
  height: 10px;
  margin-left: 18px;
  border-top: 2px solid #b09a6d;
  border-right: 2px solid #b09a6d;
  transform: rotate(45deg);
}

.count-field {
  justify-content: space-between;
  padding: 0;
  overflow: hidden;

  input {
    width: 100px;
    height: 100%;
    border: 0;
    color: #a4894f;
    background: transparent;
    font-size: 26px;
    text-align: center;
    outline: none;
    appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin: 0;
      appearance: none;
    }
  }
}

.count-button {
  width: 72px;
  height: 100%;
  padding: 0;
  border: 0;
  color: #a4894f;
  background: #faf6ef;
  font-size: 31px;

  &:active {
    background: #f2e8d7;
  }

  &:disabled {
    color: #d6cec0;
    background: #fbfaf7;
  }
}

.page-footer {
  position: fixed;
  z-index: 10;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  height: calc(106px + env(safe-area-inset-bottom));
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 30px env(safe-area-inset-bottom);
  border-top: 1px solid #eee5d7;
  box-sizing: border-box;
  background: #fffdfa;
}

.footer-button {
  width: 320px;
  height: 78px;
  border-radius: 40px;
  font-size: 31px;
  font-weight: 500;
}

.cancel-button {
  border: 1px solid #ded7ca;
  color: #b49a64;
  background: #faf7f1;
}

.save-button {
  border: 0;
  color: #fff;
  background: linear-gradient(90deg, #d0ad68, #f0c875);
}

</style>
